/* @ngInject */
function BrandSectionAssetItemController ($scope, $interval, $timeout, $rootScope, $q, $translate, NewAssetService, BrandService, BrandFontsService, Utils, UdsModalService, MessageService, ToastService, SegmentService) {
  const getBrandSectionAssetFormDialogController = () => $q.when(import('../../dialogs/brand-section-asset-form/brand-section-asset-form-dialog.controller'))
  $scope.flags = {
    loading: false
  }
  const api = {
    getBrandSectionAssetFormDialogController,
    _handleErrorDelete,
    _handleSuccessDeleteFont,
    _handleSuccessArchiveAsset,
    _deleteAssetAction,
    _deleteFontAction,
    _addAutoReloadThumbnail
  }
  this.getApi = () => api

  activate()
  function activate () {
    if (!$scope.asset) {
      return
    }

    api._addAutoReloadThumbnail($scope.asset)
  }

  function _addAutoReloadThumbnail (asset) {
    const isFont = Boolean(asset?.familyName)
    if (asset?.hasThumbnail || isFont) {
      return
    }

    const interval = $interval(() => {
      NewAssetService.checkAssetHasThumb(asset.id, 'LOW').then((hasThumb) => {
        if ($scope.asset.familyName) {
          $interval.cancel(interval)
          return
        }
        if (!hasThumb) {
          return
        }
        $interval.cancel(interval)
        const thumbUrl = $scope.asset.src.thumbnail

        $timeout(() => {
          $scope.asset.src.thumbnail = thumbUrl + `?date=${new Date().getTime()}`
        })
      })
    }, 8000)
  }

  $scope.handleAssetItemClick = (asset) => {
    $scope.openPreview({ asset: asset })
  }

  $scope.allowDownloadAsset = () => {
    const isAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()
    const isUser = $rootScope.isUser()
    const sectionAllowsDownload = $scope.asset?.allowUserDownload || $scope.section?.allowUserDownload

    return (isUser && sectionAllowsDownload) || isAdminDesigner
  }

  $scope.isAssetSelected = function (selectedAssets, asset) {
    selectedAssets = selectedAssets || []
    const foundAsset = selectedAssets.find(selectedAsset => selectedAsset.id === asset.id)
    return Boolean(foundAsset)
  }

  $scope.handleAssetSelection = function (selectedAssets, asset) {
    Utils.toggleItemOnArray(selectedAssets, asset, (a, b) => a.id === b.id)
  }

  $scope.handleDownloadAsset = function (asset, section) {
    if (section && section.type === 'FONT') {
      BrandFontsService.downloadFont(asset)
    } else {
      BrandService.downloadBrandSectionAsset(asset)
    }

    SegmentService.track('brand-download', { asset_id: asset.id })
  }

  $scope.handleUpdateAsset = function (asset, section) {
    api.getBrandSectionAssetFormDialogController().then(({ BrandSectionAssetFormDialogController }) => {
      const dialog = UdsModalService.createModal({
        controller: BrandSectionAssetFormDialogController,
        modalName: 'brandSectionAssetFormDialog',
        data: {
          asset: asset,
          section: section
        },
        onClose: (updatedAsset) => {
          if (updatedAsset) {
            asset.name = updatedAsset.name
            asset.editorEnabled = updatedAsset.editorEnabled
            asset.updatedAt = new Date().toISOString()
          }
        }
      })

      dialog.open()
    })
  }

  $scope.handleDeleteAsset = function (asset, section) {
    let pressAction
    let text

    if (section && section.type === 'FONT') {
      text = $translate.instant('dashboard.areYouSureDeleteFont')
      pressAction = () => {
        api._deleteFontAction(asset)
      }
    } else if (asset && asset.id) {
      text = $translate.instant('areYouSureDeleteAsset')
      pressAction = () => {
        if (section?.id) {
          api._deleteAssetAction(asset, section)
        } else {
          api._deleteAssetAction(asset, { id: asset.sectionId })
        }
      }
    } else {
      return
    }

    MessageService.warning({
      title: $translate.instant('warning'),
      text,
      confirmButton: $translate.instant('yesImSure'),
      cancelButton: $translate.instant('cancel'),
      press: pressAction,
      closeOnConfirm: true
    })
  }

  function _deleteFontAction (asset) {
    $scope.flags.loading = true
    BrandFontsService.deleteFont(asset.id).then(api._handleSuccessDeleteFont.bind(this, asset)).catch(api._handleErrorDelete)
  }

  function _deleteAssetAction (asset, section) {
    return BrandService.unlinkBrandSectionAsset(section.id, asset.id).then(api._handleSuccessArchiveAsset.bind(this, asset)).catch(api._handleErrorDelete)
  }

  $scope.showDownloadButton = function (asset, section) {
    if ($rootScope.isUser() && asset.allowUserDownload === false) {
      return false
    } else if (section && section.allowUserDownload === false && $rootScope.isUser()) {
      return false
    } else if (section && section.type === 'FONT' && !asset.originalFontData) {
      return false
    }
    return true
  }

  function _handleSuccessDeleteFont (deletedFont) {
    $scope.flags.loading = false

    if ($scope.data) {
      $scope.data.selectedAssets = removeDeletedElementFromSelectedAssets(deletedFont)
    }

    $scope.$emit('successDeleteFont')
  }

  function _handleSuccessArchiveAsset (deletedAsset) {
    $scope.flags.loading = false

    if ($scope.data) {
      $scope.data.selectedAssets = removeDeletedElementFromSelectedAssets(deletedAsset)
    }

    $scope.$emit('successArchiveAsset')
  }

  function _handleErrorDelete () {
    $scope.flags.loading = false
    ToastService.defaultErrorToast()
  }

  function removeDeletedElementFromSelectedAssets (deletedAsset) {
    return $scope.data?.selectedAssets.filter(selectedAsset => deletedAsset.id !== selectedAsset.id)
  }
}

export { BrandSectionAssetItemController }
